/******************************************
 *  Author : vsuthar
 *  Created On : Tue Aug 31 2021
 *  File : TableContainer.js
 *  ©Palo Alto Networks
 *******************************************/

import PropTypes from 'prop-types'
import styled from 'styled-components'

const CONTAINER = styled.div`
  .tw-border-solid.tw-border-gray-200.tw-border-0.tw-flex.tw-relative.tw-bg-white.tw-border.tw-overflow-auto {
    flex: 1 1;
  }
  .tw-flex-grow.tw-overflow-auto {
    min-height: 0 !important;
  }
  div[role=row] {
    height: auto;
  }
`

const TableContainer = ({ header, footer, children, style, className = '' }) => {
  /**
   * This component will render all the license inside selected node.
   */

  /**
 *
 * @param title
 * @param tableProps
 * @returns {JSX.Element}
 * @constructor
 */
  // console.log(tableProps)
  const clsName = `sparky-panwds-table-flex-row-size tw-flex tw-flex-col tw-rounded tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-950 ${className}`.trim()
  return (
    <CONTAINER style={style} className={clsName}>
      {header && (
        <div className="tw-border tw-border-gray-200 tw-border-l tw-rounded-full tw-pl-2 tw-py-2 tw-border-t tw-rounded-t-lg dark:tw-border-gray-950">
          {/*<Title size='xxs' addClassName={'text-gray-900'} level={2}>{header}</Title>*/}
          {header}
        </div>)
      }
      {children}
      {footer && (
        <div className="tw-border tw-border-gray-200 tw-border-l tw-border-r tw-border-b tw-rounded-b-lg dark:tw-border-gray-950">
          {footer}
        </div>
      )}
    </CONTAINER>
  )
}

TableContainer.propTypes = {
  header: PropTypes.element,
  footer: PropTypes.element,
  tableProps: PropTypes.object
}

export default TableContainer
